import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { shortUuid } from "@egalregal/shared";
import { useT } from "../../shared/i18n";

/**
 * The unknown-label preview body. The create chooser itself lives in the
 * scanner's sticky CTA bar (scanner-surface 05), so this component only states
 * what the label is; both actions stay on screen regardless of preview length.
 */
export function UnknownCodeMessage({ uuid }: { uuid: string }) {
  const t = useT();
  return (
    <Box data-testid="unknown-code-actions">
      <Typography variant="body2" color="text.secondary">
        {t("scanUnknownLabel", { id: shortUuid(uuid) })}
      </Typography>
    </Box>
  );
}
